import _extends from '@babel/runtime/helpers/extends';
import _defineProperty from '@babel/runtime/helpers/defineProperty';
import React__default, { PureComponent } from 'react';
import PT from 'prop-types';
import styled from 'styled-components';
import { $ as $f7dceffc5ad7768b$export$4e328f61c538687f } from '../3rdPartyModules/_react-aria/focus/dist/useFocusRing-BO5gj-B1.js';
import { $ as $3ef42575df84b30b$export$9d1611c77c2fe928 } from '../3rdPartyModules/_react-aria/utils/dist/mergeProps-Bjtexw5f.js';
import { f as focusPseudoElementsAfter } from '../FocusIndicator/styleMixins/focusPseudoElementsAfter-DYbe7tJD.js';
import { a as TaktIdProvider } from '../TaktIdContext/TaktIdContext-DlOuPWuU.js';
import { c as createStormTaktId } from '../TaktIdContext/TaktIdContext.utils-DaCk9T1Y.js';

const TabbedCardItemContainer = /*#__PURE__*/styled('div').attrs(({
  onFocus,
  onBlur
}) => {
  const {
    isFocusVisible,
    focusProps
  } = $f7dceffc5ad7768b$export$4e328f61c538687f();
  return {
    /*
     *`useFocusRing()` uses `onFocus` and `onBlur` props, so `mergeProps()` must be used to
     * make sure user supplied `onFocus` and `onBlur` are also called.
    */
    ...$3ef42575df84b30b$export$9d1611c77c2fe928({
      onFocus,
      onBlur
    }, focusProps),
    focusVisible: isFocusVisible
  };
}).withConfig({
  componentId: "sc-storm-ui-30054544__sc-bmmkx8-0"
})(["outline:none;position:relative;", ""], ({
  focusVisible
}) => focusVisible && focusPseudoElementsAfter);
TabbedCardItemContainer.displayName = 'TabbedCardItemContainer';
class TabbedCardItem extends PureComponent {
  render() {
    const {
      children,
      value,
      taktId,
      taktValue,
      ...rest
    } = this.props;
    // Returning tab content. Actual tab rendered in TabbedCard.
    return /*#__PURE__*/React__default.createElement(TaktIdProvider, {
      taktId: taktId,
      taktValue: taktValue,
      fallbackId: createStormTaktId('tabbed-card-item')
    }, /*#__PURE__*/React__default.createElement(TabbedCardItemContainer, _extends({}, rest, {
      role: "tabpanel",
      "aria-labelledby": value,
      tabIndex: 0
    }), children));
  }
}
_defineProperty(TabbedCardItem, "propTypes", {
  // The following are used by the parent (TabbedCard)
  /* eslint-disable react/no-unused-prop-types */
  /**
   * The contents of the card item.
   */
  value: PT.string.isRequired,
  // must be unique within parent!
  /**
   * The contents of the tab relating to this card. Any content may be passed
   * for custom formatting. We will pass isActive to any custom class or
   * function component, for use in special actions within those tabs based on state.
   * A string will give default styles.
   */
  tabChildren: PT.oneOfType([PT.element, PT.string]).isRequired,
  /* eslint-enable */
  /**
   * Must be a unique value for this tabbed card group. Used by parent to
   * determine which card is selected.
   */
  children: PT.node.isRequired
});

export { TabbedCardItem as T };
//# sourceMappingURL=TabbedCardItem-B8pqUE7P.js.map
